import React, {ReactNode} from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface NotificationBannerProps {
  children: ReactNode;
  onCloseBanner: () => void;
  imageURL: string;
  title: ReactNode;
}

export default function NotificationBanner({
  children,
  onCloseBanner,
  imageURL,
  title,
}: NotificationBannerProps): JSX.Element {
  return (
    <div className="u-flex-display homeSidepanel-notifications">
      <img className="homeSidepanel-notification-icon" src={imageURL} />
      <div className="homeSidepanel-notification-text">
        <a className="homeSidepanel-notification-close close pull-right" onClick={onCloseBanner}>
          <BenchlingIcon icon="close" />
        </a>
        <div className="u-small-spacing-bottom">{title}</div>
        {children}
      </div>
    </div>
  );
}
